import React from 'react';
import { TextField, InputLabel, makeStyles } from '@material-ui/core';
import styles from "../styles";

const useStyles = makeStyles(styles);

const MaskedField = (props) => {
  const {
    id,
    label,
    labelIcon,
    name,
    required,
  } = props;

  const classes = useStyles();
  return (
    <>
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <TextField
        name={name}
        id={id}
        size="small"
        margin="dense"
        variant="outlined"
        value={"*****"}
        type={"text"}
        disabled={true}
        required={required}
        fullWidth
        multiline={false}
        className={classes.inputField}
      />
    </>
  );
}

export default MaskedField;